<form [formGroup]="addReminderForm">
    <p-dialog
        [(visible)]="show"
        [style]="{ width: '75%' }"
        header="New Reminder"
        [modal]="true"
        [closeOnEscape]="false"
        appendTo="body"
        [closable]="false"
    >
        <div class="grid">
            <div class="col-6 p-nogutter">
                <p-floatLabel variant="on">
                    <input
                        pInputText
                        id="reminderName"
                        formControlName="Reminderinstancename"
                        name="reminderName"
                        class="col-12"
                        required
                    />
                    <label for="reminderName">Reminder Name</label>
                </p-floatLabel>
            </div>
            <div class="col-6 p-nogutter">
                <p-floatLabel variant="on">
                    <p-select
                        class="col-12"
                        id="reminderType"
                        [style]="{ 'min-width': '100%' }"
                        [virtualScroll]="true"
                        itemSize="32"
                        appendTo="body"
                        [options]="reminderTypes"
                        [filter]="true"
                        formControlName="Remindertypeid"
                        name="reminderType"
                        [autoDisplayFirst]="false"
                        required
                    ></p-select>
                    <label for="reminderType">Reminder Type</label>
                </p-floatLabel>                               
            </div>
            <div class="col-6">
                <p-floatLabel variant="on">
                    <p-select
                        class="col-12"
                        [virtualScroll]="true"
                        itemSize="32"
                        appendTo="body"
                        [options]="reminderReviewPeriods"
                        [filter]="true"
                        formControlName="Reminderreviewperiod"
                        name="reminderReviewPeriod"
                        [autoDisplayFirst]="false"
                        required
                    ></p-select>
                    <label for="review Period">Review Period</label>
                </p-floatLabel>                               
            </div>
            <div class="col-6">
                <p-floatLabel variant="on">
                    <p-select
                        class="col-12"
                        id="reminderRecipient"
                        [virtualScroll]="true"
                        itemSize="32"
                        appendTo="body"
                        [disabled]="!this.addReminderForm.controls['Remindertypeid'].value"
                        [options]="groupsForReminderType(this.addReminderForm.controls['Remindertypeid'].value)"
                        [filter]="true"
                        formControlName="Groupid"
                        [autoDisplayFirst]="false"
                        name="reminderRecipient"
                        required
                    ></p-select>
                    <label for="reminderRecipient">{{ !this.addReminderForm.controls['Remindertypeid'].value ? 'Select reminder recipients' : 'Select a recipient' }}</label>
                </p-floatLabel>                                
            </div>
            <div class="col-12">
                <div class="flex items-center">
                    <p-checkbox
                        id="reminderNotifySupervisor"
                        binary="true"
                        formControlName="Notifysupervisor"
                        name="reminderNotifySupervisor"
                    ></p-checkbox>
                    <label for="reminderNotifySupervisor" class="ml-2">Notify Supervisor</label>
                </div>                               
            </div>
            <div class="col-6">
                <p-floatLabel variant="on">
                    <p-select
                        class="col-12"
                        [virtualScroll]="true"
                        itemSize="32"
                        appendTo="body"
                        [options]="reminderScheduleTypes"
                        [filter]="true"
                        formControlName="ReminderScheduleID"
                        [autoDisplayFirst]="false"
                        name="reminderSendOn"
                        id="reminderSendOn"
                        required
                    ></p-select>
                    <label for="reminderSendOn">Send On</label>
                </p-floatLabel>                
            </div>
            <div class="col-6">
                <p-floatLabel variant="on">
                    <p-calendar
                        styleClass="w-full"
                        formControlName="Scheduletime"
                        [timeOnly]="true"
                        name="reminderSendAt"
                        id="reminderSendAt"
                        appendTo="body"
                        required
                    ></p-calendar>
                    <label for="reminderSendAt">Send &#64;</label>
                </p-floatLabel>                              
            </div>
            <div class="col-12 p-nogutter">
                <p-floatLabel variant="on">
                    <input
                        pInputText
                        type="text"
                        formControlName="Subject"
                        name="reminderSubject"
                        id="reminderSubject"
                        style="width: 100%"
                        required
                    />
                    <label for="reminderSubject">Email Subject</label>
                </p-floatLabel>
            </div>
            <div class="col-12 p-nogutter">
                <p-floatLabel variant="on">
                    <textarea
                        pInputTextarea
                        autoResize="autoResize"
                        formControlName="Comment"
                        name="reminderText"
                        id="reminderText"
                        [rows]="3"
                        style="min-height: 5em; width: 100%"
                        required
                    ></textarea>
                    <label for="reminderText">Email Text</label>
                </p-floatLabel>
            </div>
        </div>

        <ng-template #footer>
            <button
                pButton
                label="Cancel"
                icon="pi pi-times"
                (click)="onCancel()"
                class="p-button-text p-button-danger"
            ></button>
            <button
                pButton
                label="Save"
                icon="pi pi-check"
                (click)="onSave()"
                class="p-button-text p-button-success"
            ></button>
        </ng-template>
    </p-dialog>
</form>
